import { type PropsWithChildren, useRef } from 'react';
import { ImpressionArea } from '@toss/impression-area';
import { logger } from '@zep/core-logger';
import { type EventProperties } from '@/utils/analytics';
interface ViewTrackingProps {
  eventName: string;
  eventProperties?: EventProperties;
  once?: boolean;
}
export const ViewTracking = ({
  eventName,
  eventProperties,
  once = true,
  children
}: PropsWithChildren<ViewTrackingProps>) => {
  const hasTracked = useRef(false);
  return <ImpressionArea onImpressionStart={() => {
    if (once && hasTracked.current) return;
    hasTracked.current = true;
    logger.track(eventName, eventProperties);
  }} data-sentry-element="ImpressionArea" data-sentry-component="ViewTracking" data-sentry-source-file="ViewTracking.tsx">
      {children}
    </ImpressionArea>;
};